/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';

interface AdWrapperProps {
  uuid: string;
}

let setConfig: () => void = () => {};
let AdWrapper: React.FC<AdWrapperProps> = () => null;

if (typeof window !== 'undefined') {
  setConfig = require('ad-react-wrapper').setConfig;
  AdWrapper = require('ad-react-wrapper').default;
}

export { setConfig };
export default AdWrapper;
